import vZigZag from "./v-zig-zag.vue";

export default Vue => {
  Vue.component("v-zig-zag", vZigZag);
};
